export default "__VITE_ASSET__b5490c21__"